import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/form/NewsletterForm2.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/header/HeaderSection4.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/utils/CustomGsapHeaderAnimate.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/utils/DivAnimateYAxis.tsx")